import { lazyInject } from '@intelingu/core/IoC/container';
import { reaction } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import { TopicCardStore } from '@intelingu/core/stores/cards/TopicCardStore';
import { TopicOverviewCard } from './topic/TopicOverviewCard';

interface TopicStackProps {
}

@observer export class TopicStack extends Component<TopicStackProps, any> {

    reaction;
    stackElm: HTMLDivElement;
    prevLength = 0;

    @lazyInject(TopicCardStore) topicCardStore: TopicCardStore;

    componentDidMount(): void {
        this.reaction = reaction(() => this.topicCardStore.stack.length, (value) => {
            const body = document.getElementsByTagName('body')[0];

            if (value > 0) {
                body.classList.add('noscroll');
            } else {
                body.classList.remove('noscroll');
            }

            if (this.prevLength < this.topicCardStore.stack.length) {
                setTimeout(() => {
                    this.stackElm.scrollTo({
                        top: 0
                    });
                });
            }

            this.prevLength = this.topicCardStore.stack.length;
        });
    }

    render() {
        const isVisible = this.topicCardStore.stack.length > 0;

        return <div className={'topics-stack'} ref={elm => this.stackElm = elm} style={{ visibility: isVisible ? 'visible' : 'hidden' }}>
            { isVisible && <TopicOverviewCard id={0} stack={true} /> }
        </div>
    }

    componentWillUnmount(): void {
        this.reaction();
    }

}
